import { MaterialEnum } from '../../models/material.enum';
import { SpecificationEnum } from '../../models/specification.enum';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { procedureMapComposites } from '../../models/procedure-map-composites';
import { ProcedureSpecificationMaterialRule } from '../../models/specification-material-rules-config';

const baseFullContourMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicMultilayerZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLithiumSilicate,
	MaterialEnum.CeramicGlassCeramic,
	MaterialEnum.CeramicFeldspathicCeramic,
	MaterialEnum.CeramicHybrid,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.ResinAcrylicPMMA,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

const basePfmPfzMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLithiumSilicate,
	MaterialEnum.CeramicGlassCeramic,
	MaterialEnum.CeramicFeldspathicCeramic,
	MaterialEnum.CeramicHybrid,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.OtherCheckNote
];

const baseCopingOnlyMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicMultilayerZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLithiumSilicate,
	MaterialEnum.CeramicGlassCeramic,
	MaterialEnum.CeramicHybrid,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

const baseTelescopicMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

const baseTemporaryMaterials: readonly MaterialEnum[] = [
	MaterialEnum.ResinAcrylicPMMA,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

const baseInlayOnlayMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicMultilayerZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLithiumSilicate,
	MaterialEnum.CeramicGlassCeramic,
	MaterialEnum.CeramicFeldspathicCeramic,
	MaterialEnum.CeramicHybrid,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

export const rulesForFixedRestorative: ProcedureSpecificationMaterialRule = {
	ProcedureMaps: [procedureMapComposites.fixedRestorativeAll],
	UnitTypeRules: [
		{
			Id: UnitTypes.Crown,
			Specifications: [
				{
					Id: SpecificationEnum.FullContour,
					Materials: [...baseFullContourMaterials]
				},
				{
					Id: SpecificationEnum.PFM_PFZ,
					Materials: [...basePfmPfzMaterials]
				},
				{
					Id: SpecificationEnum.PFM_PFZ_CopingOnly,
					Materials: [...baseCopingOnlyMaterials]
				},
				{
					Id: SpecificationEnum.Telescopic,
					Materials: [...baseTelescopicMaterials]
				},
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypes.Crown_ThreeQuarters,
			Specifications: [
				{
					Id: SpecificationEnum.FullContour,
					Materials: [...baseFullContourMaterials]
				},
				{
					Id: SpecificationEnum.PFM_PFZ,
					Materials: [
						MaterialEnum.CeramicZirconia,
						MaterialEnum.CeramicTranslucentZirconia,
						MaterialEnum.CeramicMultilayerZirconia,
						MaterialEnum.CeramicLithiumDisilicate,
						MaterialEnum.CeramicLithiumSilicate,
						MaterialEnum.CeramicGlassCeramic,
						MaterialEnum.CeramicFeldspathicCeramic,
						MaterialEnum.CeramicHybrid,
						MaterialEnum.CeramicLabPreference,
						MaterialEnum.MetalHighNoble,
						MaterialEnum.MetalSemiPrecious,
						MaterialEnum.MetalTitanium,
						MaterialEnum.MetalCobaltChrome,
						MaterialEnum.OtherCheckNote
					]
				},
				{
					Id: SpecificationEnum.PFM_PFZ_CopingOnly,
					Materials: [
						MaterialEnum.CeramicZirconia,
						MaterialEnum.CeramicTranslucentZirconia,
						MaterialEnum.CeramicMultilayerZirconia,
						MaterialEnum.CeramicLithiumDisilicate,
						MaterialEnum.CeramicLithiumSilicate,
						MaterialEnum.CeramicGlassCeramic,
						MaterialEnum.CeramicFeldspathicCeramic,
						MaterialEnum.CeramicHybrid,
						MaterialEnum.CeramicLabPreference,
						MaterialEnum.MetalHighNoble,
						MaterialEnum.MetalSemiPrecious,
						MaterialEnum.MetalTitanium,
						MaterialEnum.MetalCobaltChrome,
						MaterialEnum.PolymerPEEK,
						MaterialEnum.Composite,
						MaterialEnum.OtherCheckNote
					]
				},
				{
					Id: SpecificationEnum.Telescopic,
					Materials: [...baseTelescopicMaterials]
				},
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypes.ImplantBased,
			Specifications: [
				{
					Id: SpecificationEnum.FullContour,
					Materials: [
						MaterialEnum.CeramicZirconia,
						MaterialEnum.CeramicTranslucentZirconia,
						MaterialEnum.CeramicMultilayerZirconia,
						MaterialEnum.CeramicLithiumDisilicate,
						MaterialEnum.CeramicLabPreference,
						MaterialEnum.MetalTitanium,
						MaterialEnum.MetalCobaltChrome,
						MaterialEnum.OtherCheckNote
					]
				},
				{
					Id: SpecificationEnum.PFM_PFZ,
					Materials: [...basePfmPfzMaterials]
				},
				{
					Id: SpecificationEnum.PFM_PFZ_CopingOnly,
					Materials: [...baseCopingOnlyMaterials]
				},
				{
					Id: SpecificationEnum.Telescopic,
					Materials: [...baseTelescopicMaterials]
				},
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypes.EggshellCrown,
			Specifications: [
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypes.MockupTooth,
			Specifications: [
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypes.Inlay,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [...baseInlayOnlayMaterials]
				}
			]
		},
		{
			Id: UnitTypes.Onlay,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [...baseInlayOnlayMaterials]
				}
			]
		},

		{
			Id: UnitTypes.VeneerOrLaminates,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [
						MaterialEnum.CeramicLithiumDisilicate,
						MaterialEnum.CeramicLithiumSilicate,
						MaterialEnum.CeramicGlassCeramic,
						MaterialEnum.CeramicFeldspathicCeramic,
						MaterialEnum.CeramicHybrid,
						MaterialEnum.CeramicLabPreference,
						MaterialEnum.ResinAcrylicPMMA,
						MaterialEnum.Composite,
						MaterialEnum.OtherCheckNote,
						MaterialEnum.OtherWax
					]
				}
			]
		}
	]
};
